var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "email-login-form"
  }, [_vm._m(0), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Welcome to Member Dashboard")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.checkEmailLogin);
            }
          }
        }, [_c('input-form-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "customMessages": `Please enter your email address.`,
            "customEmailMessage": `Please enter a valid email address`,
            "labelFor": "Email",
            "labelName": "Email",
            "inputName": "Email",
            "formGroupClass": "form-group mb-1",
            "placeholder": "Please enter your email",
            "isErrorFlagSet": _vm.emailErrorFlag,
            "vmodel": _vm.form.username
          },
          on: {
            "emitChanges": _vm.resetErrorMsg,
            "update:vmodel": function ($event) {
              return _vm.$set(_vm.form, "username", $event);
            }
          }
        }), _vm.emailErrorFlag && _vm.lockoutTime <= 0 ? _c('div', {
          staticClass: "valid-error"
        }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e(), _c('div', {
          staticClass: "left-login mb-0"
        }, [_c('div'), _c('router-link', {
          attrs: {
            "to": "/forgot-email"
          }
        }, [_c('div', {
          staticClass: "login-highlight"
        }, [_vm._v("Forgot Email?")])])], 1), _c('button', {
          staticClass: "submit-btn mt-3 next-btn ml-0",
          attrs: {
            "disabled": _vm.loginLoader || _vm.lockoutTime > 0,
            "type": "submit"
          }
        }, [_vm.loginLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Next ")], 1), _c('div', {
          staticClass: "login-signup-btn-wrap"
        }, [_c('p', [_vm._v("Don't have an account? "), _c('span', [_c('router-link', {
          attrs: {
            "to": "/signup"
          }
        }, [_vm._v("Register")])], 1)])])], 1)];
      }
    }])
  }), _vm.lockoutTime > 0 ? _c('lockout-timer', {
    attrs: {
      "lockout-seconds": _vm.lockoutTime
    },
    on: {
      "lockout-expired": _vm.handleLockoutExpired
    }
  }) : _vm._e()], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('div', {
    staticClass: "left-login"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "image-fluid"
    }
  })]), _c('div', {})])]);

}]

export { render, staticRenderFns }